import { gql } from "@apollo/client";

export const EMAIL_RERUN = gql`
  mutation emailReRun($id: Int!) {
    emailReRun(id: $id) {
      id
      message
      isError
    }
  }
`;
